module.exports = __webpack_public_path__ + "static/media/rule.225f012b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/rule.png
// module id = 980
// module chunks = 2